function importAll(r) {
  return r.keys().map(r);
}

const France_H = importAll(require.context('../assets/photos/France_H', false, /\.(png|jpe?g|svg)$/));

export default France_H;